export default "__VITE_ASSET__00dd45a6__"